

export const AddParcel = `


API_URL : ${process.env.VUE_APP_API_URL}/api/auth/

POST {{API_URL}}customers/{auth_key}/{auth_id}/add-parcel
Content-Type: application/json


*NB: ID colis est obligatoire et ne doit pas être dupliqué

{
  "tracking-number": "", // (Si le champ est vide, un numéro de suivi sera généré automatiquement )
  "parcel-receiver ": "Destinataire",
  "parcel-phone": "0666666666",
  "parcel-city" :"1", // ID dela ville 
  "parcel-address" : "Adresse Destinataire",
  "parcel-note" : "Commentaire",
  "parcel-price" : "230",
  "parcel-nature":"Nature du produit"
},


---- Success format accepted -------


  {
    "result": "success",
    "new_parcel": {
        "ID":"1256_251",
        "code": "AGA36S64",
        "receiver": "Destinataire",
        "phone": "0666666666",
        "city_id": 1,
        "city_name": "AGADIR",
        "price": 230,
        "address": "Adresse Destinataire",
        "note": "Commentaire",
        "product_nature": "Nature du produit"
    }
  }

  ---- Error format (Parcel Code Exite) -------
  {
    "result": "Parcel code already exist"
  }


  ---- Error format (Invalid Store Key) -------
  {
    "result": "store undefined"
  }

  ---- Error format (Invalid City) -------
  {
    "result": "City not valid"
  }
    

  ---- Error format (No Parcel Content) -------
  {
    "result": "End Point Parcel not valid"
  }

  ---- Error format (Invalid Parameters) -------
  {
    "result": "Invalide requests (API KEY or AUTH_ID or Content Parcel)"
  }
    

`
var root= process.env.VUE_APP_API_URL;
var api='/api/auth/client/apiFetchCities';
var res = root.concat(api);
export const ApiCities = `

API_URL : ${process.env.VUE_APP_API_URL}/api/auth/

GET {{API_URL}}cities
Content-Type: application/json




---- Success format JSON Example -------


[
  {
      "id": 1,
      "code": "AGA",
      "name": "AGADIR",
      "active": 1
  },
  {
      "id": 2,
      "code": "ING",
      "name": "Inzegane",
      "active": 1
  },
  {
      "id": 3,
      "code": "TET",
      "name": "Tetouan",
      "active": 1
  },

]

`





export const EditParcel= `

API_URL : ${process.env.VUE_APP_API_URL}/api/auth/

GET {{API_URL}}customers/{auth_key}/{auth_id}/tracking?tracking-number=CODE
Content-Type: application/json



---- Success format accepted -------
{
  "ID":"",
  "CODE": "",
  "STATUS": "Destinataire",
  "COMMENT" : "Commentaire"
},


---- Error format (Erreur no parcel ) -------
{
  "result": "no parcel found"
}

---- Error format (Erreur ID Order) -------
{
  "result": "End Point Parcel not valid"
}

---- Error format (Invalid Parameters) -------
{
  "result": "Invalide requests (API KEY or AUTH_ID or Content Parcel)"
}
`;